// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-wrapper{overflow:hidden}.button-wrapper button{float:right;margin:0 0 1rem}", ""]);
// Exports
module.exports = exports;
